import React from "react";
import Link from "helpers/link";
import Image from "components/image";
import TotalReviews from "components/total-reviews";
import Button from "components/button";
import RichText from "components/rich-text";
import clsx from "clsx/lite";

const ProductFeatures = ({ data }) => (
	<div className="hd-screen-max-width py-8">
		{data?.content &&
			<div className="w-11/12 mx-auto text-center">
				<RichText value={data.content} />
			</div>}

		<div className={clsx(
			"grid grid-cols-2 px-4 md:flex justify-center w-full mx-auto flex-wrap md:flex-nowrap md:justify-center gap-8 max-w-6xl"
		)}>
			{data.icons.map((d, i) => (
				<div key={d._key} className={clsx("flex items-center self-start flex-col md:w-full",
					data.icons.length % 2 !== 0 && i === data.icons.length - 1 && "col-span-2")}>
					<Link to={d?.url}>
						<Image className="max-w-20 h-20 md:max-w-[5.5rem] md:h-[5.5rem]" image={d.icon.asset} alt={d.text} />
					</Link>
					<p className="md:w-3/4 text-center break-words text-base md:text-lg">{d.text}</p>
				</div>
			))}
		</div>

		<Button data={data.cta} className="mt-10 mx-2 xs:mx-auto btn-center" />
		{data.showReviews && <TotalReviews direction="horizontal" />}
	</div>
);

export default ProductFeatures;
